import { FormControlLabel } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import SwitchIOS from 'shared/components/base/SwitchIOS'

const ItemFormSwitch = ({
    name,
    labelKey,
    rules,
    disabled = false,
    readOnly = false,
    defaultValue = false,
    ...props
}) => {
    const { t } = useTranslation()
    const { control } = useFormContext()
    const { labelPlacement } = props;

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            rules={rules}
            render={({ field }) => (
                <FormControlLabel
                    labelPlacement={labelPlacement}
                    label={t(labelKey)}
                    sx={{
                        width: '200px !important',
                        justifyContent: 'space-between',
                        m: 0,
                        // '& .MuiSwitch-root': { ml: -1 }
                    }}
                    control={
                        <SwitchIOS
                            {...field}
                            checked={!!field.value}
                            onChange={(e) => {
                                if (readOnly) return;
                                field.onChange(e.target.checked)
                            }}
                            disabled={disabled}
                        />
                    }
                />
            )}
        />
    )
}

export default ItemFormSwitch
